import React from 'react';
import {Translate} from 'react-redux-i18n';
import {DocumentDetails, NoCurrentVersion} from 'front-onceforall-core';
import {useSelector} from 'react-redux';
import {useSubcontractorDetailsStore} from '../SubcontractorDetailsStore';
import authenticationService from '../../../services/authentication/AuthenticationService';

import {
  documentActions,
  getDocumentPermissions,
  getTimelineVersions,
  getDossierName,
  getProcessedDocuments
} from './utils';

function DocumentsView() {
  const {organisationId} = useSelector(globalState => globalState.organisation);
  const {subcontractor, documents, dossierCountry} = useSubcontractorDetailsStore().state;
  const isBackOffice = authenticationService.roles().isBackOffice();
  const [correlationIdOpened, setCorrelationIdOpened] = React.useState(null);
  const processedDocuments = React.useMemo(() => getProcessedDocuments(dossierCountry, documents.list), [dossierCountry, documents.list]);

  const getTimelineVersionsFn = getTimelineVersions(organisationId, subcontractor);

  return (
    <>
      {documents.loading && <div className="loading-overlay"></div>}
      {documents.error && <Translate value="error.generic"/>}
      {processedDocuments.map(({dossier, documentsVersions}) => (
        <React.Fragment key={dossier}>
          <h2 className="mt-5 mb-4">
            <Translate value={getDossierName(dossier)}/>
          </h2>
          {documentsVersions.map(documentVersions => (
            <DocumentDetails
              key={dossier + documentVersions[0].correlationId}
              documentVersions={documentVersions}
              documentPermissions={getDocumentPermissions(isBackOffice, documentVersions[0])}
              documentActions={documentActions}
              correlationIdOpened={correlationIdOpened}
              handleClick={correlationId => setCorrelationIdOpened(correlationId)}
              getTimelineVersionsFn={() => getTimelineVersionsFn(documentVersions)}
              noCurrentVersion={<NoCurrentVersion/>}
            />
          ))}
        </React.Fragment>
      ))}
    </>
  );
}

export default DocumentsView;
